import { IconCalendar } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const scheduleModule: ModuleDefinition = {
  id: 'schedule',
  i18nNamespace: 'schedule',
  requires: { subject: 'appointment', action: 'read' },

  nav: {
    labelKey: 'schedule:nav',
    icon: IconCalendar,
    to: 'schedule',
    group: 'people',
    order: 30,
  },

  routes: [{ path: 'schedule', component: () => import('./SchedulePage') }],

  commands: [
    {
      id: 'schedule.new',
      labelKey: 'schedule:newAppointment',
      groupKey: 'schedule:title',
      requires: { subject: 'appointment', action: 'create' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/schedule?new=1`),
    },
  ],
};
